import { UserSummaryReferenceData, UserSummarySearchFiltersState } from "@idw-types/state/user-summary-state";
import { MonthlyUsersResult } from "@idw-types/data/monthly-users-result/monthly-users-result";

export enum UserSummaryActionTypes {
    // Reference Data
    SET_USER_SUMMARY_REFERENCE_DATA_LOADING = "SET_USER_SUMMARY_REFERENCE_DATA_LOADING",
    SET_USER_SUMMARY_REFERENCE_DATA = "SET_USER_SUMMARY_REFERENCE_DATA",
    // Search
    SET_USER_SUMMARY_SEARCH_FILTERS = "SET_USER_SUMMARY_SEARCH_FILTERS",
    SET_USER_SUMMARY_SEARCH_RESULTS_LOADING = "SET_USER_SUMMARY_SEARCH_RESULTS_LOADING",
    SET_USER_SUMMARY_SEARCH_RESULTS = "SET_USER_SUMMARY_SEARCH_RESULTS"
}

// Reference Data
type SetUserSummaryReferenceDataLoadingAction = {
    type: UserSummaryActionTypes.SET_USER_SUMMARY_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean }
};

export const setUserSummaryReferenceDataLoading = (isLoading: boolean): SetUserSummaryReferenceDataLoadingAction => ({
    type: UserSummaryActionTypes.SET_USER_SUMMARY_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetUserSummaryReferenceDataAction = {
    type: UserSummaryActionTypes.SET_USER_SUMMARY_REFERENCE_DATA,
    payload: { referenceData: UserSummaryReferenceData; }
};

export const setUserSummaryReferenceData = (referenceData: UserSummaryReferenceData): SetUserSummaryReferenceDataAction => ({
    type: UserSummaryActionTypes.SET_USER_SUMMARY_REFERENCE_DATA,
    payload: { referenceData }
});

// Search
type SetUserSummarySearchFiltersAction = {
    type: UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_FILTERS;
    payload: { searchFilters: UserSummarySearchFiltersState };
};

export const setUserSummarySearchFilters = (searchFilters: UserSummarySearchFiltersState): SetUserSummarySearchFiltersAction => ({
    type: UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetUserSummarySearchResultsLoadingAction = {
    type: UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setUserSummarySearchResultsLoading = (isLoading: boolean): SetUserSummarySearchResultsLoadingAction => ({
    type: UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetUserSummarySearchResultsAction = {
    type: UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_RESULTS;
    payload: { monthlyUsersResult: MonthlyUsersResult };
};

export const setUserSummarySearchResults = (monthlyUsersResult: MonthlyUsersResult): SetUserSummarySearchResultsAction => ({
    type: UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_RESULTS,
    payload: { monthlyUsersResult }
});

export type UserSummaryActions =
    SetUserSummaryReferenceDataLoadingAction |
    SetUserSummaryReferenceDataAction |
    SetUserSummarySearchFiltersAction |
    SetUserSummarySearchResultsLoadingAction |
    SetUserSummarySearchResultsAction